import {fixChooserForm} from './fixChooserForm';
import {parseSearchString} from "../../../utils/convertation/parseSearchString";

export const iterateCheckboxesLists = ( chooser, query ) => {
	const complexField = chooser.querySelector( 'li[data-for="complex"]' );
	const buildingsField = chooser.querySelector( 'li[data-for="building"]' );
	const search = parseSearchString( location.search );

	if ( complexField && buildingsField )
	{
		const requestedComplexes = complexField.querySelectorAll( 'input:not(.multiselect):checked' );
		
		if ( requestedComplexes.length === 1 )
		{
			const complexID = requestedComplexes[0].value;
			let buildingsCount = 0;
			
			Array.from( buildingsField.querySelectorAll( 'ul li' ) ).forEach( ( it ) => {
				if ( RegExp( complexID ).test( it.dataset.id ) )
				{
					it.style.display = '';
					buildingsCount++;
				}
				else
				{
					it.style.display = 'none';
				}
			} );

			if ( buildingsCount > 1 )
			{
				buildingsField.classList.remove( 'hidden' );
			}
		}
		else
		{
			buildingsField.classList.add( 'hidden' );
			buildingsField.querySelector( 'span.value' ).innerHTML = '';

			Array.from( buildingsField.querySelectorAll( 'ul li' ) ).forEach( ( it ) => {
				it.querySelector( 'input' ).checked = false;
			} );
		}

		fixChooserForm( chooser );
	}

	Array.from( chooser.querySelectorAll( 'li.checkboxes:not(.disabled):not(.hidden)' ) ).forEach( ( it ) => {
		const name = it.dataset.for;
		let values = '';

		Array.from( it.querySelectorAll( 'input[name*="["][value]:checked' ) ).forEach( ( input ) => {
			const value = input.value;
			const regexp = new RegExp( value );

			if ( regexp.test( search[name] ) )
			{
				input.classList.add( 'user-changed' );
			}
			
			if ( input.classList.contains( 'user-changed' ) )
			{
				query.userChanged += `,${name}%3D${value}`;
			}

			values += value + ',';
		} );

		if ( values.length > 0 )
		{
			values = values.substr( 0, values.length - 1 );
			
			if ( query.search !== '' )
			{
				query.search += '&';
			}
			
			query.search += name + '=' + values;
		}
	} );
};